import { callFetch } from './response';
import { accessTokenHeader } from './settings';

const EndPoint = {
    CreateUtmLog: () => `/v1/utm-log`
};

export function createUtmLog(data, accessToken) {
    const uri = EndPoint.CreateUtmLog(data.lineId);
    const settings = {
        method: 'POST',
        headers: { ...accessTokenHeader(accessToken) },
        body: JSON.stringify({ ...data })
    };

    return callFetch(uri, settings);
}
